
import { Component, Vue, Prop, } from 'vue-property-decorator'
import OverlayBackground from "@/components/OverlayBackground/Index.vue"
import { ControListInterface, } from '@/store/types/Analysis/ControlList'

import LongDescriptionHandlerComponent from '@/components/LongDescriptionHandler/Index.vue'
import NavigationGapComponent from '@/components/NavigationGap/Index.vue'
import Avatar from 'vue-avatar'

@Component({
  components: {
    NavigationGapComponent,
    Avatar,
    LongDescriptionHandlerComponent,
  },
})
export default class ControlDetail extends Vue {
  @Prop({ required: false, }) readonly idControlDetail!: number
  private loading = false;

  private gapControlList = this.$store.state.GapModule.GapState.controlList.gap_analysis_controls
  private historyControlList = this.$store.state.HistoryModule.HistoryState.historyNav
  private detailSelected = this.$store.state.GapModule.GapState.detailSelected
  private versionApp = this.$store.state.GapModule.GapState.version_categories
  private typeUser = this.$store.state.AuthModule.AuthState.role
  private userId = this.$route.params.id
  private newindex = 0
  private templateIndex = 0
  private detailId: number | undefined = 0
  private finalList = false
  private nameSelected = ''
  private gapData: any = {}
  private description = ''
  private question = ''
  private evidences: any[] = []
  private contentJustification = ''

  mounted () {
    this.$route.params.id
      ? (this.detailId = Number(this.$route.params.id))
      : (this.detailId = this.detailSelected.id)

    this.GetGapAnalysisControl()
  }

  // @Watch('$route', { immediate: true, })
  // onRouteChanged (newVal: any) {
  //   if (this.idControlDetail) {
  //     this.detailId = this.idControlDetail
  //     this.GetGapAnalysisControl()
  //   } else {
  //     this.detailId = Number(newVal.params.id)
  //     this.GetGapAnalysisControl()
  //   }
  // }

  private goToDataRoom () {
    if (this.typeUser === 'implementer') {
      this.$router.push({ name: 'clientDataroom', params: { id: this.userId, }, })
    } else {
      this.$mixpanel.track('Ir a Dataroom desde Control Historial')
      this.$router.push({ path: '/startup/dataroom', })
    }
  }

  private changeView (element: number) {
    if (this.$route.name === 'clientHistory' || this.$route.name === 'cardTecnical') {
      this.$emit('changeView', 1)
      return
    }
    element === 0 ? this.$router.go(-2) : this.$router.go(-1)
  }

  private nextControlBack (template: ControListInterface) {
    this.templateIndex = this.getListitems.findIndex(
      (p: ControListInterface) => p.id === template.id
    )

    this.newindex = this.templateIndex - 1
    this.detailId = this.getListitems[this.templateIndex - 1].id
    this.newindex === this.getListitems.length - 1
      ? (this.finalList = true)
      : (this.finalList = false)
    this.$store.commit('GapModule/SET_DETAIL_SELECTED', this.getListitems[this.templateIndex - 1])

    if (!this.idControlDetail) {
      this.$router.push(`/startup/project/${this.detailId}/control-detail`)
    }

    this.GetGapAnalysisControl()
  }

  private nextControlFront (template: ControListInterface) {
    this.templateIndex = this.getListitems.findIndex(
      (p: ControListInterface) => p.id === template.id
    )
    this.detailId = this.getListitems[this.templateIndex + 1].id
    this.newindex = this.templateIndex + 1
    this.newindex === this.getListitems.length - 1
      ? (this.finalList = true)
      : (this.finalList = false)
    this.$store.commit('GapModule/SET_DETAIL_SELECTED', this.getListitems[this.templateIndex + 1])
    if (!this.idControlDetail) {
      this.$router.push(`/startup/project/${this.detailId}/control-detail`)
    }

    this.GetGapAnalysisControl()
  }

  private controlChange (element: ControListInterface) {
    if (element.id !== this.detailId) {
      this.$store.commit('GapModule/SET_DETAIL_SELECTED', element)
      this.newindex = this.getListitems.findIndex((p: ControListInterface) => p.id === element.id)

      this.newindex === this.getListitems.length - 1
        ? (this.finalList = true)
        : (this.finalList = false)

      this.detailId = element.id
      if (!this.idControlDetail) {
        this.$router.push(`/startup/project/${this.detailId}/control-detail`)
      }

      this.GetGapAnalysisControl()
    }
  }

  private changeGapVersion (element: number) {
    this.$store.commit('GapModule/SET_VERSION_CATEGORIES', element)
    this.GetGapAnalysisControl()
  }

  private GetGapAnalysisControl () {
    this.loading = true
    this.$store.dispatch('GapModule/GetGapAnalysisControl', this.detailId).then((data) => {
      this.evidences = data.data.gap_analysis.evidences
      this.nameSelected = `${data.data.gap_analysis.control.code} ${data.data.gap_analysis.control.name}`
      this.gapData = data.data.gap_analysis
      this.description = this.gapData.control.description
      this.question = this.gapData.control.question
      this.newindex = this.getListitems.findIndex(
        (p: ControListInterface) => p.id === this.detailId
      )

      data.data.gap_analysis.supports.forEach((element: any) => {
        if (element.support_type === 'justification') {
          this.contentJustification = element.description
        }
      })

      this.newindex === this.getListitems.length - 1
        ? (this.finalList = true)
        : (this.finalList = false)
      this.loading = false
    })
  }

  get getListitems () {
    if (this.versionApp === 0) {
      return this.gapControlList
    } else {
      return this.historyControlList
    }
  }

  get getTypeNav () {
    if (this.$route.name === 'clients') {
      return 0
    } else {
      return 2
    }
  }
}
